import React from "react";
import { Heading } from "@usap/uicomponents";
// 20px
export default function Heading3({ title = "", ...props }) {
  return (
    <Heading
      responsive={false}
      level={3}
      margin="0px"
      color="dark-2"
      {...props}
      dangerouslySetInnerHTML={{
        __html: title
      }}
    />
  );
}
